import VizExAvatar from 'visitor-ui-component-library/avatar/VizExAvatar';
import SVGExpand from 'visitor-ui-component-library-icons/icons/SVGExpand';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import styled from 'styled-components';
import I18n from 'I18n';
import { useCustomerAgentHover } from '../contexts/CustomerAgentHoverContext';
import { calculateChatWidgetWidth } from '../widget-dimensions/calculateChatWidgetWidth';
import { ASK_ME_ANYTHING_LAUNCHER_WIDTH, COMPOSER_INLINE_MARGIN } from '../widget-dimensions/constants/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconWrapper = styled(VizExIcon).withConfig({
  displayName: "AskMeAnythingLauncher__IconWrapper",
  componentId: "sc-1rgks8f-0"
})(["margin:auto 0;transition:transform 0.5s ease,opacity 0.5s ease;transform:", ";opacity:", ";"], ({
  $hovering
}) => $hovering ? 'translateX(0)' : 'translateX(50px)', ({
  $hovering
}) => $hovering ? 1 : 0);
const AvatarGroup = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__AvatarGroup",
  componentId: "sc-1rgks8f-1"
})(["position:relative;margin-right:10px;display:flex;align-items:center;"]);
const AvatarWrapper = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__AvatarWrapper",
  componentId: "sc-1rgks8f-2"
})(["align-self:center;display:flex;"]);
const LauncherContainerWrapper = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__LauncherContainerWrapper",
  componentId: "sc-1rgks8f-3"
})([""]);
const LauncherContainer = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__LauncherContainer",
  componentId: "sc-1rgks8f-4"
})(["border:1px solid #9aacc2;border-radius:27px;width:", ";padding:0 10px;display:flex;box-shadow:#dcdcdc 0px 0px 4px;transition:width 0.5s ease;min-height:40px;overflow:hidden;cursor:pointer;position:relative;background-color:white;&:hover{border-color:", ";}"], ({
  $width
}) => $width, ({
  $accentColor
}) => $accentColor);
const PoweredByAI = styled.span.withConfig({
  displayName: "AskMeAnythingLauncher__PoweredByAI",
  componentId: "sc-1rgks8f-5"
})(["font-size:0.75rem;color:#666;margin:auto 0;transition:transform 0.5s ease,opacity 0.5s ease;transform:", ";opacity:", ";position:absolute;right:15px;top:0;bottom:0;align-self:center;"], ({
  $hovering
}) => $hovering ? 'translateX(-50px)' : 'translateX(0px)', ({
  $hovering
}) => $hovering ? 0 : 1);
const PlaceholderWrapper = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__PlaceholderWrapper",
  componentId: "sc-1rgks8f-6"
})(["display:flex;flex:1;"]);
const Placeholder = styled.span.withConfig({
  displayName: "AskMeAnythingLauncher__Placeholder",
  componentId: "sc-1rgks8f-7"
})(["margin:auto 0;"]);
const AskMeAnythingLauncher = ({
  onOpen,
  coloring,
  placeholder,
  avatarImageSrcs,
  isAIChatbot,
  browserWindowWidth,
  widgetSize
}) => {
  const {
    isHoverActive: hovering
  } = useCustomerAgentHover();
  const width = hovering ? `${calculateChatWidgetWidth(browserWindowWidth, widgetSize.width) - COMPOSER_INLINE_MARGIN * 2}px` : `${ASK_ME_ANYTHING_LAUNCHER_WIDTH}px`;
  const singleAvatarSrc = avatarImageSrcs.length > 0 ? [avatarImageSrcs[0]] : [];
  return /*#__PURE__*/_jsx(LauncherContainerWrapper, {
    children: /*#__PURE__*/_jsxs(LauncherContainer, {
      "data-test-id": "ask-me-anything-launcher",
      $hovering: hovering,
      $width: width,
      $accentColor: coloring.accentColor,
      onClick: onOpen,
      children: [/*#__PURE__*/_jsxs(PlaceholderWrapper, {
        children: [/*#__PURE__*/_jsx(AvatarGroup, {
          children: singleAvatarSrc.map((avatarSrc, index) => /*#__PURE__*/_jsx(AvatarWrapper, {
            children: /*#__PURE__*/_jsx(VizExAvatar, {
              className: "chat-head-avatar",
              size: "sm",
              src: avatarSrc,
              alt: "avatar"
            })
          }, avatarSrc !== null && avatarSrc !== void 0 ? avatarSrc : index))
        }), /*#__PURE__*/_jsx(Placeholder, {
          children: placeholder
        })]
      }), /*#__PURE__*/_jsx(IconWrapper, {
        $hovering: hovering,
        icon: /*#__PURE__*/_jsx(SVGExpand, {
          color: coloring.accentColor
        })
      }), isAIChatbot && /*#__PURE__*/_jsx(PoweredByAI, {
        $hovering: hovering,
        children: I18n.text('conversations-visitor-experience-components.askMeAnythingLauncher.poweredByAI')
      })]
    })
  });
};
AskMeAnythingLauncher.displayName = 'AskMeAnythingLauncher';
export default AskMeAnythingLauncher;